import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import IconButton from '@material-ui/core/IconButton';
import { FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';

import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from '@material-ui/core';


/**
 * Material UI button with an info dialog.
 * When the button is clicked an info dialog pops up.
 * 
 * The dialog contains just one buttons: "close".
 * Clicking on "close" close the popup. 
 * 
 * The button has a Default style corresponding to 
 * the theme (small, primary color)
 */

const styles = theme => ({
  progress: {
    marginRight: theme.spacing.unit
  },
  closeButton: {
    marginRight:16,
    marginBottom: 8,
    
  }
})

class DenyButton extends Component {

  state = {
    open: false
  };

  handleOpenDialog = () => {
    this.setState({ open: true });
  }

  handleCloseDialog = () => {
    this.setState({ open: false });
  }

  render() {
    const { 
      message,  
      onClick, 
      children, 
      title,
      close,
      cancel,
      iconButton,
      classes,
      color,
      size="medium",
      ...props 
    } = this.props;

    const ButtonComponent = iconButton ? IconButton : Button;

    const buttonColor = color || (cancel ? "secondary" : "primary");

    return [
        <ButtonComponent
          key="denyButton"
          color={buttonColor}
          size={size}
          {...props}
          onClick={this.handleOpenDialog} 
        >
          {children}
        </ButtonComponent>
      
      ,
      <Dialog
        key="denyDialog"
        fullScreen={false}
        open={!!(this.state.open)}
        aria-labelledby="responsive-deny-dialog-title">

        <DialogTitle id="responsive-deny-dialog-title">
          {title || <FormattedMessage id='deny.dialogTitle' />}
        </DialogTitle>
        <DialogContent>
          {message || <FormattedMessage id='deny.dialog.default.message' />}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCloseDialog} variant="contained" color="primary" className={classes.closeButton}>
            {close || <FormattedMessage id='deny.dialog.close.button' />}
          </Button>
        </DialogActions>
      </Dialog>
    ]
  }
}


DenyButton.propTypes = {
  message: PropTypes.object,
}

export default withStyles(styles)(DenyButton);


// WEBPACK FOOTER //
// ./src/components/DenyButton.js